// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import { useState, useEffect, useRef } from 'react';

// Custom Scripts
import { ErrorState } from '../errorHandling';
import { useLoadedData } from '../loadedData/loadedData';



// ----------------------------------------------------------------------------
//   Main Hook
// ----------------------------------------------------------------------------


/**
 * Wrapped call to enumerate media devices. Updates automatically & sorts by kind.
 */
export function useMediaDevices() {

  // Track the loaded data
  const [ mediaDevices, setMediaDevices ] = useLoadedData();

  // Inner function to load & sort the devices
  const loadMediaDevices = () => {
    try {
      setMediaDevices.setWorking();
      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          setMediaDevices.setSuccess({
            'video': devices.filter(({kind}) => kind === "videoinput"),
            'audio': devices.filter(({kind}) => kind === "audioinput"),
          });
        })
        .catch((err) => {
          setMediaDevices.setFailure(ErrorState.NO_MEDIA_DEVICES, err);
        })
    }
    catch (err) {
      setMediaDevices.setFailure(ErrorState.NO_MEDIA_DEVICES, err);
    }
  }
  
  // Update the device list on reload
  useEffect(() => { loadMediaDevices() }, []);

  // Return the media devices loaded data object
  return [ mediaDevices ];
}



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default {
  useMediaDevices,
}
